import AnimationOptions from './AnimationOptions';
export default class ElementStyleAnimationOptions extends AnimationOptions {
    constructor(init) {
        super(undefined);
        this.initialPropertyValues = {};
        this.targetPropertyValues = {};
        this.clearStyleOnComplete = false;
        Object.assign(this, init);
    }
}
//# sourceMappingURL=ElementStyleAnimationOptions.js.map